// extracted by mini-css-extract-plugin
export default {"empty_table_document":"EmptyTable_empty_table_document__VMESf","empty_table_msg":"EmptyTable_empty_table_msg__ZxnWF"};